import type LogRocket from 'logrocket';

import { IS_PRODUCTION_ENVIRONMENT } from '@/constants';

export type LogRocketInstance = typeof LogRocket;

const logRocketPromise: Promise<LogRocketInstance> = IS_PRODUCTION_ENVIRONMENT
  ? import('logrocket').then((m: { default: LogRocketInstance }): LogRocketInstance => m.default)
  : import('@/mocks/mockLogRocket').then(
      (m: typeof import('@/mocks/mockLogRocket')): LogRocketInstance =>
        m.default as unknown as LogRocketInstance,
    );

export default logRocketPromise;
